"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ = _interopRequireWildcard(require("lodash"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./newQnaPostForm.scss");

var _Username = _interopRequireDefault(require("../username/Username"));

var _flags = require("../../redux/flags/flags.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class FlagResolveMenu extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {};

    this.getContentFlags = () => {
      const {
        flags,
        id,
        type
      } = this.props;
      return _.filter(flags, {
        typeId: id,
        type
      });
    };

    this.resolveFlags = resolution => {
      const {
        resolveFlags
      } = this.props;
      const flags = this.getContentFlags();

      if (flags && flags.length) {
        const ids = _.map(flags, 'id');

        resolveFlags({
          ids,
          resolution
        });
      }
    };

    this.hideContent = () => {
      const {
        id,
        type,
        hideContent
      } = this.props;
      hideContent({
        type,
        typeId: id
      });
      this.resolveFlags('confirmed');

      _message2.default.success('Flag resolved: content hidden.');
    };

    this.unhideContent = () => {
      const {
        id,
        type,
        unhideContent
      } = this.props;
      unhideContent({
        type,
        typeId: id
      });

      _message2.default.success('Content un-hidden.');
    };
  }

  componentDidMount() {}

  render() {
    const {
      flags,
      posts,
      comments,
      participantId,
      id,
      type,
      isHidden
    } = this.props;

    const theirPosts = _.filter(posts, p => p.createdByParticipantId === participantId);

    const theirFlaggedPosts = _.filter(theirPosts, p => _.find(flags, f => f.flaggedParticipantId === p.createdByParticipantId));

    const theirHiddenPosts = _.filter(theirPosts, p => p.isHidden);

    const theirComments = _.filter(comments, c => c.participantId === participantId);

    const theirFlaggedComments = _.filter(theirComments, c => _.find(flags, f => f.flaggedParticipantId === c.participantId));

    const theirHiddenComments = _.filter(theirComments, c => c.isHidden);

    const flagsForThisContent = _.filter(flags, f => f.type === type && f.typeId === id);

    return /*#__PURE__*/_react.default.createElement("div", {
      id: "flagResolvePopup"
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: "buttonRow"
    }, isHidden ? /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this.unhideContent()
    }, " Unhide Content ") : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this.hideContent()
    }, " Hide Content "), flagsForThisContent.length ? /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this.resolveFlags('ignored')
    }, "Ignore Flags") : undefined), /*#__PURE__*/_react.default.createElement("div", {
      id: "titleRow"
    }, /*#__PURE__*/_react.default.createElement(_Username.default, {
      participantId: participantId,
      style: {
        color: '#8185B3'
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      id: "tableRow"
    }, /*#__PURE__*/_react.default.createElement("table", {
      id: "table"
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", {
      className: "center"
    }, "flagged"), /*#__PURE__*/_react.default.createElement("th", {
      className: "center"
    }, "hidden"))), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Posts"), /*#__PURE__*/_react.default.createElement("td", null, theirPosts.length), /*#__PURE__*/_react.default.createElement("td", {
      className: "center"
    }, theirFlaggedPosts.length), /*#__PURE__*/_react.default.createElement("td", {
      className: "center"
    }, theirHiddenPosts.length)), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Comments"), /*#__PURE__*/_react.default.createElement("td", null, theirComments.length), /*#__PURE__*/_react.default.createElement("td", {
      className: "center"
    }, theirFlaggedComments.length), /*#__PURE__*/_react.default.createElement("td", {
      className: "center"
    }, theirHiddenComments.length)), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
      className: "bottomRow"
    }), /*#__PURE__*/_react.default.createElement("td", {
      className: "bottomRow"
    }, theirPosts.length + theirComments.length), /*#__PURE__*/_react.default.createElement("td", {
      className: "center bottomRow"
    }, theirFlaggedPosts.length + theirFlaggedComments.length), /*#__PURE__*/_react.default.createElement("td", {
      className: "center bottomRow"
    }, theirHiddenPosts.length + theirHiddenComments.length))))));
  }

}

const mapStateToProps = state => {
  return {
    flags: selectors.getFlags(state),
    posts: selectors.getPosts(state),
    comments: selectors.getComments(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resolveFlags: flagResolution => dispatch(_flags.resolveFlagsAsync.request(flagResolution)),
    hideContent: payload => dispatch(_flags.hideContentAsync.request(payload)),
    unhideContent: payload => dispatch(_flags.unhideContentAsync.request(payload))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FlagResolveMenu);

exports.default = _default;